import React, { FC } from "react";
import "./modal.scss";
import { B2Modal, B2Button } from "@hdb/biome-2";
import HasPermission from "src/core/guards/has-permission";

interface ModalComponentProps {
  showModal: boolean;
  handleClose?: () => void;
  size?: "sm" | "md" | "lg" | "xl";
  fullscreen?: true | "sm-down" | "md-down" | "lg-down" | "xl-down" | "xxl-down";
  centered?: boolean;
  headerTitle: React.ReactNode;
  headerIcon?: React.ReactNode;
  actionConfig?: any;
  isConformationModal?: boolean;
  children: React.ReactNode;
  isIdleModal?: boolean;
  isViewMode?: boolean;
  backdropClassName?: string;
  isClosable?: boolean;
  backdrop?: true | false | 'static';
  negativeButtonText?: string;
}
const ModalComponent: FC<ModalComponentProps> = ({
  showModal,
  handleClose,
  size = "lg",
  centered = true,
  headerTitle,
  headerIcon,
  actionConfig,
  isConformationModal = false,
  children,
  isIdleModal = false,
  isViewMode,
  backdropClassName = null,
  isClosable = true,
  backdrop = true,
  negativeButtonText = "No"
}) => {
  const renderNegativeButton = () => {
    if (isConformationModal) {
      return !isIdleModal && (
        <B2Button
          variant={negativeButtonText === "No" ? "secondary" : "outline-primary"}
          onClick={handleClose}
        >
          {negativeButtonText}
        </B2Button>
      );
    }
    if (!isViewMode) {
      return (
        <B2Button
          variant="secondary"
          onClick={handleClose}
        >
          Cancel
        </B2Button>
      );
    }
    return null;
  };

  return (
    <B2Modal
      show={showModal}
      onHide={handleClose ?? (() => {})}
      size={size}
      centered={centered}
      backdropClassName={backdropClassName || ""}
      backdrop={backdrop}
    >
      {isClosable ? (
        <B2Modal.Header closeButton>
          <B2Modal.Title>
            <div style={{ padding: "1rem", display: "flex", alignItems: "center", gap: "10px" }}>
              {headerIcon && <span style={{ display: "inline-flex", alignItems: "center" }}>{headerIcon}</span>}
              {headerTitle}
            </div>
          </B2Modal.Title>
        </B2Modal.Header>
      ) : (
        <B2Modal.Header>
          <B2Modal.Title>
            <div style={{ padding: "1rem", display: "flex", alignItems: "center", gap: "10px" }}>
              {headerIcon && <span style={{ display: "inline-flex", alignItems: "center" }}>{headerIcon}</span>}
              {headerTitle}
            </div>
          </B2Modal.Title>
        </B2Modal.Header>
      )}

      <B2Modal.Body>
        <div style={{ padding: "0 1rem" }}>{children}</div>
      </B2Modal.Body>
      <B2Modal.Footer>
        <div
          style={{
            padding: "1rem",
            display: "flex",
            justifyContent: "flex-end",
            gap: "8px",
            width: "100%",
          }}
        >
          {renderNegativeButton()}

          {actionConfig?.map((action: any, index: number) =>
              action?.isHasPermissionEnabled ? (
                <HasPermission
                  key={index + 0}
                  moduleName={action?.moduleName}
                  actionName={action?.actionName}
                  isRoute={false}
                >
                  <B2Button
                    onClick={action.event}
                    variant={isConformationModal ? "danger" : (action?.variant || "primary")}
                    disabled={
                      action.hasOwnProperty("disabled")
                        ? action.disabled
                        : false
                    }
                  >
                    {action.label}
                  </B2Button>
                </HasPermission>
              ) : (
                <B2Button
                  key={index + 0}
                  onClick={action.event}
                  variant={isConformationModal ? "danger" : (action?.variant || "primary")}
                  disabled={
                    action.hasOwnProperty("disabled") ? action.disabled : false
                  }
                >
                  {action.label}
                </B2Button>
              )
            )}
        </div>
      </B2Modal.Footer>
    </B2Modal>
  );
};

export default ModalComponent;